import { Card, CardContent, CardMedia, CardActions, Typography } from '@mui/material';
import { styled } from 'styled-components';
import dayjs from 'dayjs';
import newsPlaceholder from '../../../assets/news_placeholder.png';

export interface INoticiaCard {
  noticia: any;
}

const NoticiaCard: React.FC<INoticiaCard> = ({ noticia }) => {
  return (
    <Card
      key={noticia.id}
      sx={{
        maxWidth: 280,
        width: '100%',
        minHeight: 320,
        display: 'flex',
        flexDirection: 'column',
        boxShadow: '0 4px 8px rgba(0,0,0,0.1)',
        transition: 'transform 0.3s ease',
        '&:hover': {
          transform: 'translateY(-5px)',
          boxShadow: '0 6px 12px rgba(0,0,0,0.15)'
        },
        cursor: 'pointer',
        borderRadius: '8px',
        border: '1px solid #e9eaeb'
      }}
      onClick={() => noticia.link && window.open(noticia.link, '_blank')}
    >
      <CardMedia
        component="img"
        height="180"
        image={noticia.imagem || newsPlaceholder}
        alt={noticia.titulo || 'Notícia'}
        sx={{ objectFit: 'cover', flexShrink: 0 }}
      />
      <CardContent sx={{ minHeight: '70px' }}>
        <Typography variant="h6" component="div" sx={{ fontWeight: 'bold', fontSize: '1rem', lineHeight: 1.3 }}>
          {noticia.titulo}
        </Typography>
      </CardContent>
      {
        noticia.dataPublicacao && (
          <CardActions sx={{
            borderTop: '1px solid rgba(0,0,0,0.1)',
            padding: '8px 16px',
            justifyContent: 'flex-start',
            flexShrink: 0,
            marginTop: 'auto'
          }}>
            <Typography variant="caption" color="text.secondary">
              {noticia.categoria} - {dayjs(noticia.dataPublicacao).format('DD/MM/YYYY')}
            </Typography>
          </CardActions>
        )
      }

    </Card >
  );
};

const DivCard = styled.div`
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 0px;
  position: relative;
  width: 100%;
  height: 456px;
  background: #ffffff;
  border: 1px solid #e9eaeb;
  box-shadow:
    0px 12px 16px -4px rgba(10, 13, 18, 0.08),
    0px 4px 6px -2px rgba(10, 13, 18, 0.03);
  border-radius: 16px;
`;

const HeaderCard = styled.div`
  display: flex;
  flex-direction: column;
  padding: 15px 20px;

  width: 384px;
  height: 40px;

  border-radius: 16px 16px 0px 0px;

  flex: none;
  order: 0;
  align-self: stretch;
  flex-grow: 0;
`;

export default NoticiaCard;
